import { ROLE_BASE_ROUTE, UserRole } from '../constants/user-constants.config';

export function buildRoleRoute(
  role: UserRole,
  childPath: string
): string {
  return `${ROLE_BASE_ROUTE[role]}${childPath}`;
}
